"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.editor = void 0;
var qs = require("qs");
exports.editor = function (axios) {
    return {
        // 스킨 에디터 초기화
        postDesignEditorInit: function (_a) {
            var params = _a.params;
            var query = qs.stringify(params);
            return axios.post("/design-editor/init?" + query);
        },
        // file contents 조회
        getDesignEditorFile: function (request) {
            return axios.get('/design-editor/file', request);
        },
        // 에디터 파일 임시 저장
        putDesignEditorSaveTemporal: function (_a) {
            var params = _a.params, data = _a.data;
            var query = qs.stringify(params);
            return axios.put("/design-editor/save/temporal?" + query, data);
        },
        // 에디터 파일 최종 저장
        putDesignEditorSaveFinal: function (_a) {
            var params = _a.params, data = _a.data;
            var query = qs.stringify(params);
            return axios.put("/design-editor/save/final?" + query, data);
        },
        // 파일 히스토리 조회
        getDesignEditorHistory: function (request) {
            return axios.get('/design-editor/history', request);
        },
        // file 생성
        postDesignEditorFile: function (_a) {
            var params = _a.params, data = _a.data;
            var query = qs.stringify(params);
            return axios.post("/design-editor/file?" + query, data);
        },
        // 파일 제거
        deleteDesignEditorFile: function (_a) {
            var params = _a.params, data = _a.data;
            var query = qs.stringify(params);
            return axios.delete("/design-editor/file?" + query, data);
        },
        //원본 스킨 파일 조회
        getDesignEditorFileOrigin: function (request) {
            var query = qs.stringify(request.params);
            return axios.get("/design-editor/file/origin?" + query);
        }
    };
};
